import type { IconProps } from "./thumba-coin";

export const PlayIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none" {...props}>
    <circle cx="4.5" cy="5" r="4.5" fill="#176BF2" />
    <path d="M6.75 5.03394L3.375 6.98249L3.375 3.08538L6.75 5.03394Z" fill="white" />
  </svg>
);
